import { render, staticRenderFns } from "./TplChart.vue?vue&type=template&id=aa4c609e&scoped=true&"
import script from "./TplChart.vue?vue&type=script&lang=js&"
export * from "./TplChart.vue?vue&type=script&lang=js&"
import style0 from "./TplChart.vue?vue&type=style&index=0&id=aa4c609e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4c609e",
  null
  
)

export default component.exports